import firebase from 'firebase/app';
import firebaseConfig from './firebaseConfig';
import 'firebase/auth';

export default firebase.initializeApp(firebaseConfig);
